import { render, staticRenderFns } from "./SelectProductsGifts.vue?vue&type=template&id=e719b5bc&scoped=true&"
import script from "./SelectProductsGifts.vue?vue&type=script&lang=js&"
export * from "./SelectProductsGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e719b5bc",
  null
  
)

export default component.exports